import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';

export const initialState = {
  provinceData: false
};

// A slice
const defaultDataSlice = createSlice({
  name: 'defaultData',
  initialState,
  reducers: {
    setProvinceData: (state, action) => {
      state.provinceData = action.payload;
    }
  }
});

// Actions generated from the slice
const { setProvinceData } = defaultDataSlice.actions;

// export The reducer
const defaultDataReducer = defaultDataSlice.reducer;

export default defaultDataReducer;

// Actions
export const fetchProvinceData = () => async (dispatch) => {
  try {
    const response = await fetchWrapper.get('/province/', true);
    dispatch(setProvinceData(response.results));
  } catch (error) {
    ErrorMessageHandler(error);
  }
};
